import { Button } from '@ui/button';
import type { EventResponse, VenueInfoResponse } from '../../models/show.interface';
import { format } from 'date-fns';
import type { FC } from 'react';

interface EventItemProps {
  event: EventResponse;
  venueInfo: VenueInfoResponse | null;
  handleSelectDate: (date: string, time: string, eventId: number) => void;
}

// Компонент для отображения одного события
export const EventItem: FC<EventItemProps> = ({ event, venueInfo, handleSelectDate }) => {
  const evDate = new Date(event.from);
  const time = format(evDate, 'HH:mm');

  const handleEventClick = () => {
    const formattedDate = format(evDate, 'dd.MM.yyyy');

    handleSelectDate(formattedDate, time, event.id);
  };

  return (
    <div
      key={event.id}
      data-event-id={event.id}
      className="grid grid-cols-[auto_1fr_auto] xs:grid-cols-[auto_1fr_auto] items-start py-3 gap-x-2  first:border-t-0"
    >
      {/* Левая колонка - время */}
      <div className="text-base font-medium tabular-nums pr-2">{time}</div>

      {/* Центральная колонка - только адрес, центрированный */}
      <div className="flex justify-center">
        <div className="max-w-[160px] truncate text-sm text-text-muted xs:max-w-xs sm:max-w-sm sm:text-base md:max-w-md">
          {venueInfo?.address}
        </div>
      </div>

      {/* Правая колонка - кнопка */}
      <div className="w-auto flex justify-center">
        {event.minimalPrice === 0 ? (
          <span className="inline-flex min-w-[100px] justify-center px-3 py-1.5 sm:py-2 text-sm sm:text-base font-normal">
            SOLD OUT
          </span>
        ) : (
          <Button
            onClick={handleEventClick}
            variant="default"
            className="h-auto min-w-[100px] cursor-pointer whitespace-nowrap rounded-[var(--radius-md)] bg-action-primary px-3 py-1.5 text-xs font-semibold text-action-primary-foreground hover:bg-action-primary-hover sm:py-2 sm:text-sm"
          >
            от {event.minimalPrice.toLocaleString()} ₽
          </Button>
        )}
      </div>
    </div>
  );
};
